import { useState, useEffect, useCallback } from 'react'
import Footer from '../components/Footer'
import ReactMarkdown from 'react-markdown'
import aboutTxt from '../files/About.md'
import aboutTxtSq from '../files/About_sq.md'
import Header from '../components/Header'
import { getLanguage } from '@mzaednica/core'
import { LANGUAGES } from '../i18n/settings/languages'
import { connect } from 'react-redux'

const About = ({ language }) => {
  const [markdown, setMarkdown] = useState('')

  const fetchMarkdown = useCallback(async () => {
    const res = await fetch(language === LANGUAGES.MK ? aboutTxt : aboutTxtSq)
    const text = await res.text()
    setMarkdown(text)
  }, [language])

  useEffect(() => {
    fetchMarkdown()
  }, [fetchMarkdown])

  return (
    <>
      <Header />
      <ReactMarkdown className="container mx-auto pt-5 pb-10 md">
        {markdown}
      </ReactMarkdown>
      <Footer />
    </>
  )
}

const mapStateToProps = (state) => ({
  language: getLanguage(state),
})

export default connect(mapStateToProps)(About)
